// Analytics Configuration
// Replace these values with your actual tracking IDs

export const ANALYTICS_CONFIG = {
  // Google Analytics 4 Measurement ID
  // Format: G-XXXXXXXXXX
  // Get this from: https://analytics.google.com/
  GA_TRACKING_ID: process.env.REACT_APP_GA_TRACKING_ID || 'GA_TRACKING_ID',
  
  // Bing Webmaster Tools Validation Token
  // Get this from: https://www.bing.com/webmasters/
  BING_VALIDATION_TOKEN: process.env.REACT_APP_BING_VALIDATION_TOKEN || 'YOUR_BING_VALIDATION_TOKEN_HERE',
  
  // Enable/disable tracking (useful for development)
  ENABLE_TRACKING: process.env.NODE_ENV === 'production',
  
  // Optional: Enable debug mode for Google Analytics
  DEBUG_MODE: process.env.NODE_ENV === 'development',
};

export default ANALYTICS_CONFIG; 